import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { JoyrideOptions, JoyrideStepInfo } from '../joyride.domain';
import { JoyrideStepService } from './joyride-step.service';
import { JoyrideOptionsService } from './joyride-options.service';

@Injectable({ providedIn: 'root' })
export class JoyrideService {
  private readonly stepService = inject(JoyrideStepService);
  private readonly optionsService = inject(JoyrideOptionsService);

  private tourInProgress: boolean = false;
  private tours: Observable<JoyrideStepInfo>;

  startTour(options?: JoyrideOptions): Observable<JoyrideStepInfo> {
    if (!this.tourInProgress) {
      this.tourInProgress = true;
      if (options) {
        this.optionsService.setOptions(options);
      }
      this.tours = this.stepService.startTour().pipe(finalize(() => (this.tourInProgress = false)));
      this.tours.subscribe();
    }
    return this.tours;
  }

  closeTour(): void {
    if (this.isTourInProgress()) {
      this.stepService.close();
    }
  }

  isTourInProgress(): boolean {
    return this.tourInProgress;
  }
}
